import React from "react";
import type { StaffStatus } from "../../types/types";

export const STAFF_STATUS_LABELS: Record<StaffStatus, string> = {
  not_activated: "Not activated",
  invited: "Invited",
  active: "Active",
  deactivated: "Deactivated",
  suspended: "Suspended",
};

interface Props {
  counts: Record<StaffStatus, number>;
  selected: StaffStatus[];
  onChange: (statuses: StaffStatus[]) => void;
  disabled?: boolean;
}

export default function StaffStatusFilter({
  counts,
  selected,
  onChange,
  disabled = false,
}: Props) {
  return (
    <div
      role="group"
      aria-label="Filter staff by status"
      className="flex flex-wrap gap-2"
    >
      {(Object.keys(STAFF_STATUS_LABELS) as StaffStatus[]).map((status) => (
        <button
          key={status}
          type="button"
          disabled={disabled}
          aria-pressed={selected.includes(status)}
          title={
            disabled
              ? "Search is unavailable until the service is updated"
              : undefined
          }
          className={`rounded-full border px-3 py-2 text-sm disabled:opacity-50 ${selected.includes(status) ? "border-green-600 bg-green-50 text-green-800" : "border-gray-300 bg-white text-gray-700"}`}
          onClick={() =>
            onChange(
              selected.includes(status)
                ? selected.filter((s) => s !== status)
                : [...selected, status],
            )
          }
        >
          {STAFF_STATUS_LABELS[status]} ({counts[status]})
        </button>
      ))}
    </div>
  );
}
